var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { RestServiceBase } from "@ane/core/lib/services/RestServiceBase";
import { SUBSCRIPTION_TYPES } from "../models/SubscriberModels.js";
import { WPSProxyConverter } from "@ane/core/lib/services/WPSProxy";
import { buildOdataQuery } from "@ane/core/lib/utils/ODataUtils";
import { parseError } from "./expapiv2/ExpApiV2.utils.js";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
const apiVersion = "2023-09-30-preview";
let SubscriberV2Resources = class extends RestServiceBase {
  constructor() {
    super(EnvironmentService.endpoints.default, "", parseError);
  }
  loadSubscribers(payload) {
    return __async(this, null, function* () {
      const address = buildOdataQuery(
        {
          skip: 0,
          top: 1
        },
        {
          baseUrl: `/workspaces/${payload.workspaceId}/notification-subscriptions`,
          cleanOdataDollarSignPrefix: true,
          additionalQueryParams: {
            "api-version": apiVersion,
            notificationSubscriptionType: SUBSCRIPTION_TYPES.EntityBase,
            entityType: payload.entityType,
            entityId: payload.entityExternalId
          }
        }
      );
      const result = yield this._get(address);
      return result;
    });
  }
  setSubscribers(payload) {
    return __async(this, null, function* () {
      const address = `/workspaces/${payload.workspaceId}/notification-subscriptions/${payload.notificationSubscription.id}?api-version=${apiVersion}`;
      const result = yield this._put(
        payload.notificationSubscription,
        address
      );
      return result;
    });
  }
  loadAdminSubscribers(workspaceId, notificationCategory, skip, top) {
    return __async(this, null, function* () {
      const address = buildOdataQuery(
        {
          skip,
          top
        },
        {
          baseUrl: `/workspaces/${workspaceId}/notification-subscriptions`,
          cleanOdataDollarSignPrefix: true,
          additionalQueryParams: {
            "api-version": apiVersion,
            notificationSubscriptionType: SUBSCRIPTION_TYPES.Admin,
            notificationCategory
          }
        }
      );
      const result = yield this._get(address);
      return result;
    });
  }
};
SubscriberV2Resources = __decorateClass([
  WPSProxyConverter()
], SubscriberV2Resources);
const SubscriberV2Resources$1 = new SubscriberV2Resources();
export {
  SubscriberV2Resources$1 as default
};
//# sourceMappingURL=SubscriberV2Resources.js.map
